export default __webpack_public_path__ + "static/media/img-0585-poland-full-face.2768997d.png";